














import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
	name: 'WarningDialog',

	computed: {
		...mapGetters(['warning']),
	},

	methods: {
		clearWarning() {
			this.$store.commit('setWarning', '');
		},
	},
});
